<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: black;
}
main {
  position: relative;
}
a {
  color: inherit;
  text-decoration: none;
}
@font-face {
  font-family: "blok";
  src: url("~@/assets/blok.heavy.ttf");
}
</style>
